import { Typography } from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FxPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/fx/ofx');
  }, []);
  return (
    <div>
      <Typography.Title level={3}>FX Page</Typography.Title>
    </div>
  );
};

export default FxPage;
